module.exports = __webpack_public_path__ + "static/media/AZ.1af6405d.png";